function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { getUiOptions, getDefaultFormState } from "../Schema/utils";
import { getCurrentLocale } from "./utils";

class LocalizedStringField extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      expanded: false
    });

    _defineProperty(this, "onToggle", () => {
      this.setState(prevState => ({
        expanded: !prevState.expanded
      }));
    });

    _defineProperty(this, "onChange", formData => {
      const schema = this.props.schema;
      const newFormData = getDefaultFormState(schema, formData);
      console.log('LocalizedString:onChange', newFormData);

      if (this.props.onChange) {
        this.props.onChange(newFormData);
      }
    });

    _defineProperty(this, "getUiSchema", () => {
      const _this$props = this.props,
            schema = _this$props.schema,
            uiSchema = _this$props.uiSchema;
      const currentLocale = getCurrentLocale(this.props);
      const uiOptions = getUiOptions(uiSchema);
      let localizedUiSchema = {
        "ui:fieldset": ["locale:" + currentLocale]
      };
      Object.keys(schema.properties).map(name => {
        const localeProps = name.split(':');
        const locale = localeProps[1];
        const title = uiOptions.title && uiOptions.title + ":" + locale;
        const help = uiOptions.help;
        localizedUiSchema[name] = {
          "ui:options": {
            "placeholder": uiOptions.placeholder,
            "widget": uiOptions.widget || "text",
            "title": title,
            "language": locale,
            "help": help
          }
        };
      });
      return _extends({}, localizedUiSchema, {
        "ui:layout": "field",
        "ui:collapsible": true,
        "ui:expanded": false
      });
    });

    _defineProperty(this, "getField", () => {
      const uiSchema = this.getUiSchema();
      return _extends({}, this.props, {
        uiSchema: uiSchema
      });
    });
  }

  render() {
    const _this$getField = this.getField(),
          schema = _this$getField.schema,
          uiSchema = _this$getField.uiSchema,
          formData = _this$getField.formData,
          registry = _this$getField.registry;

    const ObjectField = registry.fields.ObjectField;
    return React.createElement(ObjectField, _extends({}, this.props, {
      schema: schema,
      uiSchema: uiSchema,
      formData: formData,
      onChange: this.onChange
    }));
    return React.createElement("div", null, React.createElement("p", null, JSON.stringify(uiSchema)), React.createElement(ObjectField, _extends({}, this.props, {
      schema: schema,
      uiSchema: uiSchema,
      formData: formData,
      onChange: this.onChange
    })));
  }

}

_defineProperty(LocalizedStringField, "defaultProps", {});

export default LocalizedStringField;